import React from 'react'
import { Button, Checkbox, Form, Input, Icon } from 'antd'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { requestLogin } from '../../redux/Admin/actions'

import LogoWhite from 'assets/images/logo-white.png'

import './index.css'

const FormItem = Form.Item

class SignIn extends React.Component {
    handleSubmit = e => {
        const { requestLogin } = this.props

        e.preventDefault()
        this.props.form.validateFields((err, { email, password }) => {
            if (!err) {
                requestLogin({ email, password, remember: true })
            }
        })
    }

    render() {
        const { getFieldDecorator } = this.props.form
        const { isLoading } = this.props

        return (
            <div className="gx-app-login-wrap">
                <div className="gx-app-login-container">
                    <div className="gx-app-login-main-content">
                        <div className="gx-app-logo-content">
                            <div className="gx-app-logo-content-bg" />
                            <div className="gx-app-logo-wid">
                                <h1>Sign In</h1>
                                <p>By Signing In, you can avail full features of our services.</p>
                                <p>Get an account!!!</p>
                            </div>
                            <div className="gx-app-logo">
                                <img alt="Ekko" src={LogoWhite} style={{ width: '50%' }} />
                            </div>
                        </div>
                        <div className="gx-app-login-content">
                            <Form onSubmit={this.handleSubmit} className="gx-signin-form gx-form-row0">
                                <FormItem>
                                    {getFieldDecorator('email', {
                                        rules: [
                                            {
                                                required: true,
                                                type: 'email',
                                                message: 'The input is not valid E-mail!'
                                            }
                                        ]
                                    })(<Input placeholder="Email" />)}
                                </FormItem>
                                <FormItem>
                                    {getFieldDecorator('password', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Please input your Password!'
                                            }
                                        ]
                                    })(<Input type="password" placeholder="Password" />)}
                                </FormItem>
                                {/* <FormItem>
                                    {getFieldDecorator('remember', {
                                        valuePropName: 'checked',
                                        initialValue: true
                                    })(<Checkbox>I accept</Checkbox>)}
                                    <Link to="/terms">
                                        <span className="gx-signup-form-forgot gx-link">Term & Conditions</span>
                                    </Link>
                                </FormItem> */}
                                <FormItem>
                                    <Button type="primary" className="gx-mb-0" htmlType="submit">
                                        {isLoading ? <Icon type="loading" spin /> : <span>Sign In</span>}
                                    </Button>
                                    {/*<span>or</span> <Link to="/signup">Sign Up</Link>*/}
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const WrappedNormalLoginForm = Form.create()(SignIn)

const mapStateToProps = ({ admin }) => ({
    isLoading: admin.loading.auth
})

const mapActionsToProps = dispatch => ({
    requestLogin: bindActionCreators(requestLogin, dispatch)
})

export default connect(
    mapStateToProps,
    mapActionsToProps
)(WrappedNormalLoginForm)
